export default "__VITE_ASSET__BNqUEPNG__"